<template>
  <div class="table-responsive m-3">
    <table class="table">
      <thead class="thead-light">
        <tr>
          <th
v-for="header in headers" :key="header.text"
            class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">{{ header.text }}</th>
          <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"></th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="item in data" :key="item.id" @click="$emit('edit-record', item)">
          <td v-for="header in headers" :key="header.value">
            <span v-if="isDate(item[header.value])">{{ formatDate(item[header.value]) }}</span>
            <span
v-else-if="isBoolean(item[header.value])"
              :class="{ 'badge': true, 'badge-success': item[header.value], 'badge-danger': !item[header.value] }">
              {{ item[header.value] ? 'Si' : 'No' }}
            </span>
            <span v-else>{{ item[header.value] }}</span>
          </td>
          <td>
            <button class="btn btn-link p-2 mx-1 mb-0" @click.stop="$emit('edit-record', item)">
              <i class="fa-duotone fa-solid fa-pen-to-square"></i></button>
            <button class="btn btn-link p-2 mx-1 mb-0" @click.stop="$emit('delete-record', item)">
              <i class="fa-regular fa-trash"></i>
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script setup>
import { format, parseISO, isValid } from 'date-fns';

defineProps({
  data: Array,
  headers: Array
});

const isDate = (value) => {
  if (typeof value !== 'string') {
    return false;
  }
  const date = parseISO(value);
  return isValid(date);
};

const formatDate = (value) => {
  if (typeof value !== 'string') {
    return 'Fecha inválida';
  }
  const date = parseISO(value);
  return isValid(date) ? format(date, 'dd/MM/yy hh:mm:ss a') : 'Fecha inválida';
};

const isBoolean = (value) => {
  return typeof value === 'boolean';
};
</script>

<style scoped>
.table-responsive {
  overflow-x: auto;
}

.table {
  width: 100%;
  margin-bottom: 1rem;
  color: #212529;
  border-collapse: collapse;
  background-color: #fff;
  box-shadow: 0 4px 8px rgba(124, 124, 124, 0.1);
  border-radius: 0.75rem;
  overflow: hidden;
}

.table th,
.table td {
  padding: 1rem;
  vertical-align: middle;
  border-top: 1px solid #dee2e6;
  word-wrap: break-word;
  /* Evita el desbordamiento de texto */
}

.table thead th {
  vertical-align: bottom;
  border-bottom: 2px solid #dee2e6;
  background-color: #eae9e9;
  color: #000 !important;
  font-weight: bold;
  text-align: left;
}

.table tbody tr {
  transition: background-color 0.3s, transform 0.3s;
}

.table tbody tr:hover {
  background-color: #f1f3f5;
  transform: scale(1.01);
  cursor: pointer;
}

.table tbody td {
  text-align: left;
}

.table .btn-link {
  color: #007bff;
  text-decoration: none;
}

.table .btn-link:hover {
  color: #0056b3;
  text-decoration: underline;
}

.table .btn-link i {
  font-size: 1.2rem;
}

.badge {
  display: inline-block;
  padding: 0.25em 0.4em;
  font-size: 75%;
  font-weight: 700;
  line-height: 1;
  text-align: center;
  white-space: nowrap;
  vertical-align: baseline;
  border-radius: 0.375rem;
}

.badge-success {
  color: #fff;
  background-color: #28a745;
}

.badge-danger {
  color: #fff;
  background-color: #dc3545;
}
</style>